module.exports = __webpack_public_path__ + "img/notion-avatar.ce3ea311.webp";